// extracted by mini-css-extract-plugin
module.exports = {"mobileChatHolder":"MobileChat_mobileChatHolder__1qBqf","mobileChatMessageHolder":"MobileChat_mobileChatMessageHolder__XUReO"};